import React from 'react';
import ReactARIATooltip from 'react-aria-tooltip';

import TooltipContainer from './styled/TooltipContainer';
import { TooltipProps } from './types';

const Tooltip: React.FC<TooltipProps> = props => {
  const { children, direction, message, ...passedProps } = props;
  if (!message) return null;
  return (
    <TooltipContainer {...passedProps}>
      <ReactARIATooltip
        direction={direction}
        message={message}
        eventType="hover"
      >
        {children}
      </ReactARIATooltip>
    </TooltipContainer>
  );
};

export default Tooltip;
